// a v4 uuid without dashes: the id format Flipper uses for chat messages
const uuidHex = () => crypto.randomUUID().replace(/-/g, '')

export default uuidHex
